export const shadows = {
  xs: '0px 0px 0px 1px rgba(0, 0, 0, 0.4)',
  sm: '0px 4px 4px rgba(0, 0, 0, 0.18), 0px 0px 1px rgba(0, 0, 0, 0.1)',
  base: '0px 0px 1px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.3), 0px 1px 2px rgba(0, 0, 0, 0.56)',
  md: '0px 0px 1px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.3), 0px 2px 4px -1px rgba(0, 0, 0, 0.56)',
  lg: '0px 0px 1px rgba(0, 0, 0, 0.1), 0px 10px 15px -3px rgba(0, 0, 0, 0.3), 0px 4px 6px -2px rgba(0, 0, 0, 0.55)',
  xl: '0px 0px 1px rgba(0, 0, 0, 0.4), 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 20px 25px -5px rgba(0, 0, 0, 0.6)',
  '2xl':
    '0px 0px 1px rgba(0, 0, 0, 0.25), 0px 25px 50px -12px rgba(0, 0, 0, 0.8), 0px 17px 50px -52px rgba(0, 0, 0, 0.5)',
  outline: '0px 0px 0px 3px rgba(63, 153, 225, 0.6)',
  inner: 'inset 0px 2px 4px rgba(0, 0, 0, 0.46)',
  none: 'none',
}
